export default [
  {
    path: '/communityDetail',
    name: 'communityDetail',
    component: () => import('@/views/community/Detail.vue'),
    meta: { title: '' }
  },
  {
    path: '/communityPublish',
    name: 'communityPublish',
    component: () => import('@/views/community/Publish.vue'),
    meta: { title: 'app_publish' }
  },
  {
    path: '/communityColumnPage',
    name: 'communityColumnPage',
    component: () => import('@/views/community/ColumnPage.vue'),
    meta: { title: 'pc_community_special' }
  },
  {
    path: '/communitySearchPage',
    name: 'communitySearchPage',
    component: () => import('@/views/community/SearchPage.vue'),
    meta: { title: 'app_search' }
  },
  {
    path: '/comDetailLevel',
    name: 'comDetailLevel',
    component: () => import('@/views/community/DetailLevel.vue'),
    meta: { title: 'wx_share_title_h5', customWechatShare: true, pageLevel: 3 }
  },
  {
    path: '/newPage',
    name: 'page',
    component: () => import('@/views/community/NewPage.vue'),
    meta: { title: '' }
  },
  {
    path: '/publishArticle',
    name: 'publishArticle',
    component: () => import('@/views/community/PublishArticle.vue'),
    meta: { title: '', pageLevel: 3 }
  },
  {
    path: '/publishPost',
    name: 'publishPost',
    component: () => import('@/views/community/PublishPost.vue'),
    meta: { title: '' }
  }
]
